import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
	IRequestPut,
	IRequestStatus,
} from 'app/interfaces/google-calendar.interface';

@Injectable()
export class GoogleCalendarService {
	constructor(private httpApi: HttpClient) {}

	public getStatus() {
		return this.httpApi.get<IRequestStatus>(
			'professionals/profile/googleCalendar'
		);
	}

	public saveIntegration(code: string) {
		return this.httpApi.put<IRequestPut>(
			'professionals/profile/googleCalendar',
			{ code }
		);
	}

	public removeIntegration() {
		return this.httpApi.put<IRequestPut>(
			'professionals/profile/googleCalendar',
			{ deactivated: true }
		);
	}
}
